import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { log } from "console";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-update-applicant_mob-email",
  templateUrl: "./update-spouse-email.component.html",
  styleUrls: ["./update-spouse-email.component.scss"],
})
export class UpdateSpouseEmailId implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  applicationNo: string = '';
  spouseEmailIdData:any;
  selectedAadharType: string;
  selectedFileName: string = "";
  uploadedFile: string | ArrayBuffer;
 errorMessageEmail:string = "";

  
  selectedType : string;   
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
  
  }




  fetchSpouseEmailId() {
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>",this.mobileNumber);
    this.isLoading = true;
    this.auditTrailService
      .fetchSpouseEmailIdService({ applicationNo: this.applicationNo })
      .subscribe(
        (data) => {
          console.log(data, "=========>");
          this.isLoading = false;
          this.spouseEmailIdData = data;
          // if(data.status === 'SUCCESS') {
          // }
          // else {
          //   this.errorToast("Please Enter correct Application No.");
          //   this.applicationNo ='';
          // }
        },
        (error) => {
          this.isLoading = false;
          this.exportImportService.errorToast(
            "Please Enter correct Application No."
          );
        }
      );
  }

  async successToast(msg:any) {
    await this._snackBar.open(
        msg,
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}

async errorToast(msg:any) {
  await this._snackBar.open(
      msg,
      "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
      }
  );
}




updateSpouseEmailId() {
  this.selectedType= localStorage.getItem('selectedAadharType');
 console.log(">>>>>>>>>>>>>>>>OK",this.spouseEmailIdData.emailId);
  if (this.errorMessage) {
    return;
  }

  let payload: any ={
    applicationNo:this.applicationNo,
    uploadedBase64:this.uploadedFile,
    emailId:this.spouseEmailIdData.emailId,
    selectedAadharType: localStorage.getItem('selectedAadharType'),
  }
   console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>",payload);
   

  //  if (this.applicantMobileData.mobileNumber !== "") {
  //   this.errorMessageMobile = 'Please Enter Mobile Number';
  //   return;
  // }
   
  if (!this.uploadedFile) {
    this.errorMessage = 'Please select a file.';
    return;
  }

  this.isLoading = true;
  this.auditTrailService.updateSpouseEmailIdService(payload)
  .subscribe((data) => {
     console.log(data,"=========>");
    this.isLoading = false;
    if(data.status === 'SUCCESS') {
      this.successToast("Spouse Email Id Changed Successfully");
      this.fetchSpouseEmailId();
      window.location.reload();
    }
    else {
      this.errorToast(data.errorMessage); 
    }
  }, error => {
    this.isLoading = false;
  });

}


  validateInput(event: any): void {

    const input = event.key;
    const isNumeric = /^[0-9]*$/.test(input);
    const isBackspaceOrDelete = event.code === 'Backspace' || event.code === 'Delete';
 
  }


  validateMobileNumber(value: string): void {
    if (!value && !this.selectedFileName) {
      this.errorMessageMobile = 'Mobile number is required.';
    } else {
      this.errorMessageMobile = '';
    }
  }
  

checkInputValue(event: any) {
  if (event.target.value === '') {
    // location.reload();
  }
}



onFileSelect(event) {
  this.submitDisabled = true;
  const selectedFile = event.target.files[0];
  if (!selectedFile) {
    this.errorMessage = "Please select a file.";
    return;
  }

  if (selectedFile.type !== "application/pdf") {
    this.errorMessage = "Please select a PDF file only.";
    return;
  }

  this.errorMessage = "";
  this.submitDisabled = false;

  this.selectedFileName = selectedFile.name;

  const reader = new FileReader();
  reader.onload = () => {
    this.uploadedFile = reader.result;
    this.errorMessage = "";
  };

  reader.onerror = () => {
    this.errorMessage = "Error occurred while reading the file.";
  };

  reader.readAsDataURL(selectedFile);
}

}